"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var buildOneMetroResolverOverrides_exports = {};
__export(buildOneMetroResolverOverrides_exports, {
  buildOneMetroResolverOverrides: () => buildOneMetroResolverOverrides
});
module.exports = __toCommonJS(buildOneMetroResolverOverrides_exports);
var import_module = __toESM(require("module"), 1);
var import_path = __toESM(require("path"), 1);
var import_absorbedPackages = require("../utils/absorbedPackages");
function buildOneMetroResolverOverrides(param) {
  var { projectRoot } = param;
  var require2 = import_module.default.createRequire(projectRoot + "/");
  var emptyPath = require2.resolve("@vxrn/vite-plugin-metro/empty", {
    paths: [
      projectRoot
    ]
  });
  var projectPackagePath = import_path.default.join(projectRoot, "package.json");
  var absorbed = (0, import_absorbedPackages.absorbedPackageAliases)(projectRoot, "native");
  return function(defaultConfig) {
    var _ref;
    var _defaultConfig_resolver, _defaultConfig_resolver1, _defaultConfig_resolver2;
    var resolver = {
      ...defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.resolver,
      assetExts: [
        .../* @__PURE__ */ new Set([
          ...(_ref = defaultConfig === null || defaultConfig === void 0 ? void 0 : (_defaultConfig_resolver = defaultConfig.resolver) === null || _defaultConfig_resolver === void 0 ? void 0 : _defaultConfig_resolver.assetExts) !== null && _ref !== void 0 ? _ref : [],
          "txt"
        ])
      ],
      extraNodeModules: {
        ...defaultConfig === null || defaultConfig === void 0 ? void 0 : (_defaultConfig_resolver1 = defaultConfig.resolver) === null || _defaultConfig_resolver1 === void 0 ? void 0 : _defaultConfig_resolver1.extraNodeModules
      },
      nodeModulesPaths: defaultConfig === null || defaultConfig === void 0 ? void 0 : (_defaultConfig_resolver2 = defaultConfig.resolver) === null || _defaultConfig_resolver2 === void 0 ? void 0 : _defaultConfig_resolver2.nodeModulesPaths,
      resolveRequest: function resolveRequest(context, moduleName, platform) {
        var _defaultConfig_resolver3;
        var defaultResolveRequest = (defaultConfig === null || defaultConfig === void 0 ? void 0 : (_defaultConfig_resolver3 = defaultConfig.resolver) === null || _defaultConfig_resolver3 === void 0 ? void 0 : _defaultConfig_resolver3.resolveRequest) || context.resolveRequest;
        if (moduleName === "react-native-worklets" || moduleName.startsWith("react-native-worklets/")) {
          return defaultResolveRequest({
            ...context,
            originModulePath: projectPackagePath
          }, moduleName, platform);
        }
        if (moduleName in absorbed) {
          return {
            type: "sourceFile",
            filePath: absorbed[moduleName]
          };
        }
        if (moduleName.endsWith(".css")) {
          return {
            type: "sourceFile",
            filePath: emptyPath
          };
        }
        if (/_middleware.tsx?$/.test(moduleName)) {
          return {
            type: "sourceFile",
            filePath: emptyPath
          };
        }
        if (/\.server(\.[jt]sx?)?$/.test(moduleName)) {
          return {
            type: "sourceFile",
            filePath: emptyPath
          };
        }
        if (moduleName === "react-native-svg") {
          var res = defaultResolveRequest(context, moduleName, platform);
          var svgSrcSuffix = `${import_path.default.sep}src${import_path.default.sep}index.ts`;
          if (res && "filePath" in res && res.filePath.includes(svgSrcSuffix)) {
            return {
              ...res,
              filePath: res.filePath.replace(svgSrcSuffix, `${import_path.default.sep}lib${import_path.default.sep}commonjs${import_path.default.sep}index.js`)
            };
          }
          return res;
        }
        var res1 = defaultResolveRequest(context, moduleName, platform);
        if (res1 && "filePath" in res1 && /\.server\.[jt]sx?$/.test(res1.filePath)) {
          return {
            type: "sourceFile",
            filePath: emptyPath
          };
        }
        return res1;
      }
    };
    return {
      ...defaultConfig,
      resolver
    };
  };
}
//# sourceMappingURL=buildOneMetroResolverOverrides.js.map
